import React from 'react';
import classNames from 'classnames';

import { LetterIcon } from '../assets';

import MessageIndicator from './MessageIndicator';
import classes from './MessagingEnvelope.module.scss';

function MessagingEnvelope({ className, unreadMessages, onClick }) {
  const hasUnreadMessages = unreadMessages > 0;
  return (
    <button
      id="messaging-button"
      className={classNames(classes.envelope, classes.btn, className)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label={`Messages with ${unreadMessages ?? 'no'} unread messages`}
    >
      <span className={classes.iconWrapper}>
        <LetterIcon />
        {hasUnreadMessages && (
          <MessageIndicator
            className={classes.indicator}
            unreadMessages={unreadMessages}
          />
        )}
      </span>
    </button>
  );
}

export default MessagingEnvelope;
